<template>
  <div>
    <div class="mb-4">
      <h3>{{ !categorySelected ? $t('purchase.catalogue.title') : categorySelected }}</h3>
    </div>

    <!-- <div class="filter__box mt-3 mb-4">
      <button class="children__filter__button" @click.prevent="toggleCategory = !toggleCategory">
        <span>{{ selectedChildrenCategories.name ? selectedChildrenCategories.name : '-' }}</span>
        <div class="icon" v-if="childrenCategories.length">
          <i class="fe fe-chevron-down"></i>
        </div>
      </button>
      <button class="parent__filter__button" @click.prevent="changeToggle()"><FilterIcon /></button>
    </div> -->

    <a-row
      class="category-selected"
      v-if="categorySelected && categories.length"
    >
      <a-col
        style="cursor: pointer"
        :span="12"
        class="all"
        @click.prevent="() => handleSelectCategory()"
      >
        {{ $t('purchase.catalogue.all_product') }}
      </a-col>
      <a-col
        :span="12"
        class="search"
      >
        <a-input-search
          :default-value="$route.query.search_query"
          :placeholder="$t('form.placeholder_search_product')"
          @change="handleSearch($event.target.value)"
          style="width: 100%"
        />
      </a-col>
    </a-row>

    <div
      v-if="!products.length && !fetching"
      class="my-4"
    >
      <div class="mx-auto">
        {{ $t('purchase.catalogue.product_not_found') }}
      </div>
    </div>
    <div class="product-wrapper">
      <div class="product-grid-list">
        <div
          v-for="(product, index) in products"
          :key="index"
          class="product-grid-list__item"
        >
          <CatalogueListItem
            :product="product"
            :prices="prices"
            :list_product="products"
            :dataDiscount="dataDiscount"
          />
        </div>
      </div>
    </div>

    <div v-if="total > perPage" class="mt-5">
      <a-pagination
        :default-current="+$route.query.page"
        :total="total"
        :page-size="perPage"
        class="mx-auto d-flex justify-content-center"
        @change="(page) => $router.push({ query: { ...$route.query, page } })"
        v-if="!loading && products.length"
      />
    </div>

    <Transition name="fade">
      <div v-if="toggleCategory" class="category-backdrop" @click="toggleCategory = !toggleCategory"></div>
    </Transition>
    <Transition name="category-transition">
      <div v-if="toggleCategory" class="category-menu">
        <div class="category-menu__body">
          <div class="category__wrapper">
            <template v-if="childrenCategories.length">
              <div class="category__label" v-for="(child, idx) in childrenCategories" :key="idx" @click.prevent="selectChildrenCategories(child)">{{ child.name }}</div>
            </template>
            <template v-else>
              <div class="not-found-category d-flex justify-content-center align-items-center">Tidak ada category</div>
            </template>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CatalogueListItem from './CatalogueListItem.vue'
// import FilterIcon from '@/components/Icons/Filter.vue'

const sort = [
  {
    label: 'Product Name [A-Z]',
    value: ['product_name', 'asc'],
  },
  {
    label: 'Product Name [Z-A]',
    value: ['product_name', 'desc'],
  },
]

export default {
  components: {
    CatalogueListItem,
    // FilterIcon,
  },
  data() {
    return {
      dataDiscount: [],
      fetching: true,
      products: [],
      perPage: 35,
      total: 0,
      categories: [],
      prices: [],
      categorySelected: null,
      warehouse_id: null,
      allCategories: [],
      childrenCategories: [],
      selectedChildrenCategories: {},
      toggleCategory: false,
    }
  },
  computed: {
    ...mapState('user', {
      channelId: (state) => state.channel_id,
    }),
    loading() {
      return this.$store.state.purchase.loading
    },
    /**
     * @returns {object[]}
     */
    sortItems() {
      return sort
    },
    /**
     * @returns {string}
     */
    selectedSort() {
      return this.$route.query.sort && this.$route.query.order
        ? [this.$route.query.sort, this.$route.query.order].join('__')
        : undefined
    },
  },
  watch: {
    '$route.params'(val) {
      this.fetchWarehouseId()
      if (this.$route.query.category) {
        const findCategory = this.categories.find(
          (item) => +item.id === +this.$route.query.category,
        )

        this.categorySelected = findCategory.name
      } else {
        this.categorySelected = null
      }

      if (this.allCategories.length) {
        const filterCategory = this.allCategories.find(item => item.id === Number(val.category_id))
        this.childrenCategories = filterCategory.children

        if (filterCategory.children && filterCategory.children.length) {
          this.selectedChildrenCategories = filterCategory.children[0]
        } else {
          this.selectedChildrenCategories = filterCategory
        }
      }
    },
    categories(value) {
      const tempCategories = []
      const flatCategory = (categories = []) => {
        categories.forEach(category => {
          tempCategories.push(category)
          flatCategory(category.children)
        })
      }
      flatCategory(value)
      this.allCategories = tempCategories
      const { category_id } = this.$route.params
      if (tempCategories.length) {
        const filterCategory = tempCategories.find(item => item.id === Number(category_id))
        this.childrenCategories = filterCategory.children

        if (filterCategory.children && filterCategory.children.length) {
          this.selectedChildrenCategories = filterCategory.children[0]
        } else {
          this.selectedChildrenCategories = {}
        }
      }
    },
  },
  created() {
    // this.debouncedQueryChanged = debounce((val) => {
    //   this.$router.push({
    //     path: '/purchase/catalogue',
    //     query: { ...this.$route.query, search_query: val || undefined },
    //   })
    // }, 250)
  },
  mounted() {
    this.fetchWarehouseId()
    this.fetchProducCategories()
  },
  methods: {
    ...mapActions('settings', ['changeToggle']),
    selectChildrenCategories(value) {
      this.selectedChildrenCategories = value
      this.fetchWarehouseId(value.id)
      this.toggleCategory = !this.toggleCategory
    },
    async fetchWarehouseId(category_id = null) {
      if (this.$store.state.user.user_data.seller) {
        this.$store
          .dispatch('warehouse/GETWAREHOUSE_SELLER', {
            channel_id: this.$store.state.user.user_data.channel_id,
            seller_id: this.$store.state.user.user_data.seller.map(
              (item) => item.id,
            ),
          })
          .then(({ data }) => {
            this.fetchProducts(data.map((item) => item.warehouse_id), category_id)
          })
      } else {
        this.$store
          .dispatch('warehouse/GETWAREHOUSE_COVERAGE', {
            channel_id: this.$store.state.user.user_data.channel_id,
            area_id: this.$store.state.user.user_data.area_id,
          })
          .then(({ data }) => {
            this.fetchProducts(data.map((item) => item.warehouse_id), category_id)
          })
      }
    },
    async fetchProducts(warehouse_id, category_id = null) {
      const warehouse_query =
        warehouse_id.length > 1
          ? `warehouse_id=${warehouse_id.join('&warehouse_id=')}`
          : `warehouse_id=${warehouse_id[0]}`
      this.fetching = true
      this.$store
        .dispatch('product/GETPRODUCTLIST', {
          channel_id: this.$store.state.user.user_data.channel_id,
          limit: this.perPage,
          warehouse_query: warehouse_query,
          category: category_id || this.$route.params.category_id,
        })
        .then(({ data, total_row }) => {
          const products = data || []
          const listCatalogId = products.map(v => { return v.catalogs[0].id })
          if (listCatalogId.length > 0) {
            this.fetchFlagDiscount(listCatalogId)
          }
          const product_id = products.map((item) => item.id)
          this.products = products
          this.total = total_row
          return this.$store.dispatch('price/GETPRICEPRODUCT', {
            id: product_id,
            channel_id: this.$store.state.user.user_data.channel_id,
            price_area_id: this.$store.state.user.user_data.price_area_id,
            customer_category_id: this.$store.state.user.user_data.customer_category_id,
          })
        })
        .then(({ data }) => {
          this.fetching = false
          this.prices = data
        })
    },
    async fetchFlagDiscount(listCatalogId) {
      this.$store
        .dispatch('product/GETDISCOUNT', {
          channel_id: this.$store.state.app.channel_id,
          business_id: this.$store.state.app.business_id,
          catalog_ids: listCatalogId.toString(),
          customer_category_id: this.$store.state.user.user_data.customer_category_id,
        })
        .then((response) => {
          this.dataDiscount = response.data
        })
    },
    async fetchProducCategories() {
      this.$store
        .dispatch('product/GETPRODUCTCATEGORIES', {
          channel_id: this.$store.state.user.channel_id,
        })
        .then((response) => {
          this.categories = response
          if (this.$route.query.category) {
            const findCategory = response.find(
              (item) => +item.id === +this.$route.query.category,
            )

            this.categorySelected = findCategory.name
          } else {
            this.categorySelected = null
          }
        })
    },
    onSortSelectChange(value) {
      const [sort, order] = value.split('__')
      this.$router.push({
        query: {
          ...this.$route.query,
          sort,
          order,
        },
      })
    },
    getImageCategory(name) {
      switch (name.toLowerCase()) {
        case 'personal care':
          return 'https://ik.imagekit.io/fepca/Group_2618_WU6T0KDcz.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1654826893652'

        case 'household':
          return 'https://ik.imagekit.io/fepca/Group_2619_AInFPjQum.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1654826893718'

        case 'food & beverages':
          return 'https://ik.imagekit.io/fepca/Group_2620_A_h8JPtPi.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1654826895004'

        case 'pharmaceutical':
          return 'https://ik.imagekit.io/fepca/Group_2621_mpezEqu-h.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1654826895539'

        case 'pet food':
          return 'https://ik.imagekit.io/fepca/Group_2622_e5kvziEH0.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1654826896281'

        default:
          return ''
      }
    },
    handleSelectCategory(id) {
      if (!id) {
        this.categorySelected = null
        this.$router.push({
          path: '/purchase/catalogue',
          query: { page: 1, limit: this.perPage },
        })
      } else {
        const findCategory = this.categories.find((item) => item.id === id)

        this.categorySelected = findCategory.name

        this.$router.push({
          path: '/purchase/catalogue',
          query: { ...this.$router.query, page: 1, category: id },
        })
      }
    },
    getCategoryName(category) {
      const vendor_name = this.$store.state.app.vendor_name

      if (vendor_name.toLowerCase() === 'kino') {
        switch (category.name.toLowerCase()) {
          case 'house hold':
            return 'Household'

          case 'food & beverage':
            return 'food & beverages'

          case 'food beverages':
            return 'food & beverages'

          default:
            return category.name
        }
      }

      return category.name
    },
    handleSearch(value) {
      if (value.length >= 3 || !value) {
        setTimeout(() => {
          this.$router.push({
            path: '/purchase/catalogue',
            query: { ...this.$route.query, search_query: value || undefined },
          })
        }, 250)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.product {
  &-filter {
    width: 100%;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;
  }

  &-category {
    background: #fff;
    color: #1a1a1a;
    border-radius: 8px;
    padding: 1.5rem;
    width: auto;
    height: auto;

    &__item {
      cursor: pointer;

      img {
        width: 75.82px;
        height: 81.67px;

        @media (max-width: 567px) {
          width: 37px !important;
          height: 45px !important;
        }
      }

      &-title {
        text-transform: uppercase;
        color: #929292;

        @media (max-width: 567px) {
          font-size: 8px !important;
        }
      }
    }

    // &__title {
    //   text-transform: uppercase;
    //   font-style: normal;
    //   font-weight: bold;
    //   font-size: 16px;
    //   line-height: 19px;
    //   color: #000000;
    // }

    // &__item {
    //   width: 155.82px;
    //   height: 161.67px;
    //   left: 590px;
    //   top: 62px;
    //   // background: #FFFFFF;
    //   // box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
    //   border-radius: 5px;
    //   margin: 0 1.5rem !important;

    //   &-title {
    //     text-transform: uppercase;
    //     color: #929292;
    //   }
    // }

    // @media (max-width: 567px) {
    //   &__item {
    //     margin: .5rem !important;
    //     // width: 105.82px;
    //     // height: 111.67px;
    //     width: 25px;
    //     height: auto;

    //     img {
    //       height: 10px;
    //       width: auto;
    //     }

    //     &-title {
    //       font-size: 2px;
    //     }
    //   }

    // }
  }
}

.product-list {
  width: 229px;
  // height: 30rem;

  @media (max-width: 567px) {
    width: 45%;
    // height: 25rem;
    margin: 10px 7px !important;
  }
}
.product-section-category {
  padding: 0 98px;
  @media (max-width: 567px) {
    padding: 0;
  }
}

.product-content{
  justify-content: center;
  @media (max-width: 600px){
    justify-content: space-between;
  }
}

.catalog-icon {
  background: #fff !important;
  padding: 7px 12px;
  border-radius: 50%;
}

.category-selected {
  height: 51px;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  margin: 3rem 0;

  @media (max-width: 600px){
    margin: 1rem 0;
  }

  .all {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.05em;
    color: #000000;
  }
}
.card_kategori {
  background: #fff;
  border-radius: 6px;
  width: 100%;
  flex: 1 245px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &:last-child {
    margin-right: 0;
  }
  img {
    width: 100%;
    margin: auto;
    cursor: pointer;
  }

  p {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 0;
    text-align: center;
    letter-spacing: 0.05em;
    color: #929292;
    text-transform: uppercase;
  }
}

.swiper-slide {
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: all 0.2s ease-in;
}
.prev-arrow {
  position: relative;
  top: 75px;
  z-index: 3;
  width: 35px;
}
.next-arrow {
  position: relative;
  top: 75px;
  z-index: 3;
  width: 35px;
}
// Banner Slider
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  height: auto;
}

.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}

.filter__box {
  display: none;
  width: 100%;

  button.children__filter__button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    width: 80%;
    height: 35px;
    border: 1px solid #ABABAB;
    border-radius: 5px;
    background: transparent;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #777777;

    span {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 90%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    div.icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 10%;
      font-size: 15px;
      font-weight: 700;
    }
  }

  button.parent__filter__button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15%;
    height: 35px;
    border: 1px solid #ABABAB;
    border-radius: 5px;
    background: transparent;
  }

  @media (max-width: 600px){
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

h1.not-found-product {
  width: 100%;
  font-size: 20px;
  font-weight: 600;
  color: #ABABAB;
}

.category-transition {
  &-enter-active {}

  &-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  &-enter,
  &-leave-to {
    transform: translateY(100%);
  }
}

.category-backdrop {
  transition: all .2s ease-out;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.5);
}

.category-menu {
  transition: all .3s ease-out;
  position: fixed;
  height: 70vh;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background-color: #fff;
  border-radius: 1rem 1rem 0 0;

  &__header {
    display: flex;
    justify-content: space-between;
    font-size: 1.25rem;
    padding: .75rem 1rem;
    border-bottom: 1px solid #efefef;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 500;

    .btn-close {
      border: 0;
      font-size: 1.5rem;
      padding: 0 .25rem;
      line-height: 1;
    }
  }

  &__body {
    height: 100%;
    overflow-y: auto;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  &__item {
    padding: .5rem 1rem;
    align-items: center;
    font-weight: 500;

    &:not(:last-child) {
      border-bottom: 1px solid #efefef;
    }
  }
}

.category__wrapper {
  width: 100%;
  padding: .5rem 1rem;

  .category__label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: var(--biz-base-40);

    &:hover {
      font-weight: bold;
    }
  }

  .not-found-category {
    width: 100%;
    height: 100%;
    padding: 20px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: var(--biz-base-40);
  }
}
</style>
